import { useState } from 'react';

import { Box, Typography } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

interface PreviewColumnProps {
  previewUrl?: string;
  isExpired: boolean;
}

const useStyles = makeStyles()(() => ({
  previewContainer: {
    height: '55px',
    width: '93.5px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  previewImage: {
    objectFit: 'cover',
    borderRadius: '4px',
    height: '55px',
    width: '93.5px'
  },
  placeholderBox: {
    height: '55px',
    width: '93.5px',
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  placeholderText: {
    lineHeight: '1.2',
    maxWidth: '80px',
    textAlign: 'center',
    whiteSpace: 'pre-line',
    wordBreak: 'break-word'
  }
}));

const PreviewColumn = ({ previewUrl, isExpired }: PreviewColumnProps) => {
  const { classes } = useStyles();
  const [isImageError, setIsImageError] = useState(false);
  const placeholderText = isExpired ? 'Expired' : 'No preview available';

  return (
    <Box paddingLeft={1}>
      {previewUrl && !isImageError ? (
        <img
          className={classes.previewImage}
          src={previewUrl}
          alt="Post Preview"
          onError={() => setIsImageError(true)}
        />
      ) : (
        <Box className={classes.placeholderBox}>
          <Typography
            variant="caption"
            color="textSecondary"
            className={classes.placeholderText}
          >
            {placeholderText}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PreviewColumn;
